import { useEffect, useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "@jourfx/convex/client";
import { Button, Card, CardContent, CardHeader, CardTitle, Input, Label, Skeleton } from "@jourfx/ui";

type Id<T extends string> = string & { __tableName: T };

export function AssessmentPanel({ appointmentId }: { appointmentId: string }) {
  const assessment = useQuery(api.assessments.index.getByAppointment, {
    appointmentId: appointmentId as Id<"appointments">,
  });
  const update = useMutation(api.assessments.index.update);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (assessment?.reasonForAssessment) {
      setReason(assessment.reasonForAssessment);
    }
  }, [assessment?.reasonForAssessment]);

  if (assessment === undefined) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Ersteinschätzung</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Skeleton className="h-4 w-64" />
          <Skeleton className="h-9 w-full" />
        </CardContent>
      </Card>
    );
  }

  if (assessment === null) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Ersteinschätzung</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Keine Ersteinschätzung vorhanden.
          </p>
        </CardContent>
      </Card>
    );
  }

  const handleSave = async () => {
    await update({
      assessmentId: assessment._id as Id<"initialAssessments">,
      patch: {
        reasonForAssessment: reason,
      },
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Ersteinschätzung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="text-sm text-muted-foreground">
          {assessment.name} · {assessment.dateOfBirth} · {assessment.placeOfResidence}
        </div>
        <div className="space-y-1">
          <Label htmlFor="initial-assessment-reason" className="text-sm font-medium text-muted-foreground">
            Grund
          </Label>
          <Input
            id="initial-assessment-reason"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
          />
        </div>
        <div>
          <Button type="button" onClick={handleSave}>
            Speichern
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
